
import React from 'react';

interface ForYouCardProps {
    title: string;
    subtitle: string;
    imageUrl: string;
    icon: string;
    onClick: () => void;
    comingSoon?: boolean;
}

const ForYouCard: React.FC<ForYouCardProps> = ({ title, subtitle, imageUrl, icon, onClick, comingSoon }) => {
    return (
        <div 
            onClick={!comingSoon ? onClick : undefined}
            className={`flex-shrink-0 w-40 h-52 rounded-2xl shadow-lg relative overflow-hidden transform transition-transform ${!comingSoon ? 'hover:scale-105 cursor-pointer' : 'cursor-default'}`}
        >
            <img src={imageUrl} alt={title} className={`w-full h-full object-cover ${comingSoon ? 'grayscale brightness-50' : ''}`} />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
            
            {comingSoon && (
                <div className="absolute inset-0 flex items-center justify-center z-10">
                    <div className="bg-black/60 border-2 border-white/50 text-white font-bold text-sm px-3 py-1 rounded transform -rotate-12 backdrop-blur-sm shadow-xl">
                        coming soon
                    </div>
                </div>
            )}

            <div className="absolute bottom-0 left-0 p-3 text-white">
                <i className={`ph-duotone ph-${icon} text-3xl mb-1`}></i>
                <h3 className="font-bold text-sm leading-tight">{title}</h3>
                <p className="text-xs opacity-80">{subtitle}</p>
            </div>
        </div>
    );
};

export default ForYouCard;
